export default "__VITE_ASSET__zUiHzaMc__"